"use client";
import { jsx } from "react/jsx-runtime";
import { showNotification } from "../../feedback/Notification/Notification.actions.js";
import Icon from "../../graphics/Icon/Icon.js";
import { useLocaleText } from "../../../hooks/useLocaleText.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Box } from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import { forwardRef, useState, useEffect, useMemo } from "react";
import Button from "../Button/Button.js";
const _CopyButton = forwardRef((props, ref) => {
  const {
    variant = "icon",
    notificationLabel = "Teksten er kopieret",
    copiedLabel = "Kopieret",
    copyLabel = "Kopiér",
    withNotification,
    text,
    timeout = 2e3,
    control,
    ...rest
  } = props;
  const isControlled = "control" in props;
  const texts = useLocaleText();
  const clipboard = useClipboard({ timeout });
  const [copyText, setCopyText] = useState(text);
  useEffect(() => {
    if (variant === "anchor") {
      const { href, hash } = window.location;
      const url = href.replace(hash, "");
      setCopyText(`${url}${text}`);
    }
  });
  const copyHandler = () => {
    clipboard.copy(copyText);
    if (withNotification) {
      showNotification({
        text: notificationLabel,
        title: texts.success,
        type: "success",
        autoClose: timeout
      });
    }
  };
  useMemo(() => {
    if (isControlled && control) {
      copyHandler();
    }
  }, [control]);
  return /* @__PURE__ */ jsx(Box, { ...rest, children: variant === "button" ? /* @__PURE__ */ jsx(
    Button,
    {
      ref,
      variant: clipboard.copied ? "cta" : "default",
      text: clipboard.copied ? copiedLabel : copyLabel,
      onClick: !isControlled ? copyHandler : void 0
    }
  ) : /* @__PURE__ */ jsx(
    Icon,
    {
      ref,
      color: clipboard.copied ? "success" : "dark",
      name: clipboard.copied ? "Check" : "Link",
      onClick: !isControlled ? copyHandler : void 0
    }
  ) });
});
_CopyButton.displayName = "CopyButton";
const CopyButton = sharedHandler(_CopyButton);
CopyButton.displayName = _CopyButton.displayName;
export {
  CopyButton as default
};
